<mdb-stepper #stepper [linear]="true">
    <mdb-step [stepForm]="formEmail" [name]="'Inserisci e-mail'">
        <form [formGroup]="formEmail">
            <div class="row justify-content-center">
                <div class="col-md-3">
                    <p>Inserisci la tua e-mail</p>
                </div>
            </div>
            <div class="row justify-content-center mt-2">
                <div class="col-md-3">
                    <mdb-form-control>
                        <input mdbInput mdbValidate type="email" id="email" class="form-control"
                            formControlName="email" />
                        <label mdbLabel class="form-label" for="first-name">E-mail <span
                                class="text-muted">(obbligatoria)</span></label>
                    </mdb-form-control>
                </div>
            </div>
        </form>
        <div class="row justify-content-center mt-2">
            <div class="col-md-3">
                <button id="form-example-next-step" class="btn btn-primary w-100" (click)="sendCode()">
                    Avanti
                </button>
            </div>
        </div>

    </mdb-step>
    <mdb-step [stepForm]="formCodice" [name]="'Inserisci codice'">

        <form [formGroup]="formCodice">
            <div class="row justify-content-center mt-2">
                <div class="col-md-3">
                    <p>Inserisci il codice che ti abbiamo inviato via e-mail</p>
                </div>
            </div>
            <div class="row justify-content-center mt-2">
                <div class="col-md-3">
                    <mdb-form-control>
                        <input mdbInput mdbValidate type="text" id="codice" class="form-control"
                            formControlName="codice" />
                        <label mdbLabel class="form-label" for="company-name">Codice <span
                                class="text-muted">(obbligatorio)</span></label>
                    </mdb-form-control>
                </div>
            </div>
        </form>
        <div class="row justify-content-center mt-2">
            <div class="col-md-3">
                <button id="form-example-next-step" class="btn btn-primary w-100" (click)="verificaCodice()">
                    Avanti
                </button>
            </div>
        </div>


    </mdb-step>
    <mdb-step [stepForm]="formPassword" [name]="'Nuova Password'">
        <form [formGroup]="formPassword">

                <div class="row justify-content-center mt-2">
                    <div class="col-md-3">
            <mdb-form-control>
                        <input mdbInput mdbValidate type="password" id="pass" class="form-control"
                            formControlName="password" />
                        <label mdbLabel class="form-label" for="pass">Inserisci Nuova Password <span
                                class="text-muted">(obbligatoria)</span></label>
            </mdb-form-control>
                    </div>
                </div>

                <div class="row justify-content-center mt-2">
                    <div class="col-md-3">
            <mdb-form-control>
                        <input mdbInput mdbValidate type="password" id="conf" class="form-control"
                            formControlName="conferma" />
                        <label mdbLabel class="form-label" for="conf">Conferma Password <span
                                class="text-muted">(obbligatoria)</span></label>
            </mdb-form-control>
                    </div>
                </div>
        </form>

        <div class="row justify-content-center mt-2">
            <div class="col-md-3">
                <button id="form-example-next-step" class="btn btn-primary w-100" (click)="cambiaPassword()">
                    CONFERMA
                </button>
            </div>
        </div>

    </mdb-step>
    <mdb-step [name]="'Fine'">
        <div class="row justify-content-center m-5">
            <div class="col-md-6 text-center">
                <p>La tua password è stata cambiata con successo</p>
                <p>Ora puoi accedere <a href="#" [routerLink]="['/login']">dalla pagina di Login</a>.</p>
            </div>
        </div>

    </mdb-step>
</mdb-stepper>